import { createUseStyles } from 'react-jss';
import classnames from 'classnames';

import { Theme } from '@app/theme';
import { Session, useIncentiveText, useMe } from '@app/api';
import { LabeledSection } from '@app/core';
import { useTranslation } from 'react-i18next';
import { useTrackingParams } from '@app/analytics';

const useStyles = createUseStyles((theme: Theme) => ({
  content: {
    ...theme.fonts.caption,
    color: theme.colors.inkPrimary,
    display: 'flex',
    alignItems: 'flex-start',
    padding: theme.marginBase * 2,
    borderRadius: theme.borderRadius.std,
    whiteSpace: 'pre-wrap',
  },
  icons: {
    fontSize: theme.iconSize.large,
    marginRight: theme.marginBase,
  },
  incentiveIcon: {
    color: theme.colors.green,
  },
  incentiveContainer: {
    backgroundColor: theme.colors.greenMuted,
  },
}));

interface Props {
  session: Session;
  sessionLinkId?: string;
}

export const IncentiveBlock = ({ sessionLinkId, session }: Props) => {
  const classes = useStyles();
  const { data: me } = useMe(true);
  const params = useTrackingParams();
  const incentiveText = useIncentiveText(
    sessionLinkId,
    session,
    undefined,
    undefined,
    !me ? (params.country as string) : undefined,
  );
  const { t } = useTranslation();

  if (!incentiveText) {
    return null;
  }
  return (
    <LabeledSection label={t('application.info.incentive')}>
      <p className={classnames(classes.content, classes.incentiveContainer)}>
        <i
          className={classnames(
            'ri-gift-line',
            classes.incentiveIcon,
            classes.icons,
          )}
        />
        {incentiveText}
      </p>
    </LabeledSection>
  );
};
